import { ref, reactive, computed, getCurrentInstance } from 'vue';
import { defineStore } from 'pinia';

// import { useRoute } from 'vue-router';

import Ajax from '@utils/ajax';
import { isSm } from '../../utilities/mediaQuery';

export const useSettings = defineStore('settings', () => {
    // const route = useRoute();

    const state = reactive({});

    const settings = ref(prebook.settings || {});

    // Fetch Settings
    const fetchSettings = async (section = null) => {
        // const response = await Settings.init().get({ section })
        const response = await Ajax.get('get_settings', { section });
        // Log('SETTINGS', response)
        window.prebook.settings = response.data;
        settings.value = response.data;
        // const response = await Settings.init().all() ||[]
        // console.log('response', response)
        return response.data;
    };

    // General Settings.
    const general = computed(() => {
        return settings.value.general || {};
    });

    // Business Settings.
    const business = computed(() => {
        return settings.value.business || {};
    });

    // Working Hours Settings.
    const businessHours = computed(() => {
        return settings.value.business_hours || {};
    });

    // Working Hours Settings.
    const daysOff = computed(() => {
        return settings.value.days_off || {};
    });

    // Payment Settings.
    const payment = computed(() => {
        return settings.value.payment || {};
    });

    const options = prebook.options || {};

    const customizer = computed(() => prebook.customizer || {});

    // prebook widget
    const isWidget = computed(() => {
        // if mobile then booking form will be widget
        // if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) return true;
        // console.log(isSm)
        if(isSm) return true

        const instance = getCurrentInstance();
        return instance?.appContext?.app?.config?.globalProperties?.config?.isWidget || false;
    });

    const addons = ref(prebook.addons || {});

    const labels = ref(prebook.labels || {});

    const isRTL = computed(() => {
        return prebook.is_rtl || false;
    });

    // Return.
    return {
        general,
        business,
        businessHours,
        payment,
        fetchSettings,
        options,
        daysOff,
        customizer,
        isWidget,
        addons,
        labels,
        isRTL
    };

});
